import React from 'react';
import { Link } from 'react-router-dom';
import './Apps.css';
import BartMenuIcon from '../images/bartmenu-icon.png';
import DishListIconMark from '../images/dishlist-icon-mark.png';

function Apps() {
  return (
    <div className="apps">
      <section className="apps-header">
        <h1>Our Apps</h1>
        <p>Discover our collection of applications designed to make life better</p>
      </section>

      <section className="apps-overview">
        <div className="content-wrapper">
          <div className="apps-grid">
            
            {/* BartMenu App Card */}
            <div className="app-card">
              <div className="app-card-header">
                <h2>BartMenu</h2>
                <p className="app-tagline">Create party menus for your cocktail robot machines</p>
              </div>
              
              <div className="app-card-content">
                <div className="app-preview">
                  <div className="app-icon app-icon-artwork">
                    <img src={BartMenuIcon} alt="BartMenu app icon" />
                  </div>
                  <p>Perfect for entertaining guests with cocktail robots like Bartesian and Bev. Create beautiful, professional menus that showcase your drink selection.</p>
                </div>
                
                <div className="app-highlights">
                  <ul>
                    <li>✨ Automatic pod updates</li>
                    <li>📸 Custom cocktail photos</li>
                    <li>🎨 Multiple menu designs</li>
                    <li>🖨️ Print-ready layouts</li>
                  </ul>
                </div>
                
                <div className="app-status available">
                  <span className="status-badge">Available Now</span>
                </div>
              </div>
              
              <div className="app-card-actions">
                <Link to="/apps/bartmenu" className="learn-more-btn primary">
                  Learn More & Download
                </Link>
              </div>
            </div>

            {/* DishList App Card */}
            <div className="app-card">
              <div className="app-card-header">
                <h2>DishList</h2>
                <p className="app-tagline">Family meal planning made simple and fair</p>
              </div>
              
              <div className="app-card-content">
                <div className="app-preview">
                  <div className="app-icon app-icon-artwork dishlist-icon-artwork">
                    <img src={DishListIconMark} alt="DishList app icon" />
                  </div>
                  <p>End the daily "what's for dinner?" struggle. Give every family member a voice in meal planning while reducing the burden on parents.</p>
                </div>
                
                <div className="app-highlights">
                  <ul>
                    <li>🗳️ Family voting system</li>
                    <li>📅 Smart weekly planning</li>
                    <li>🛒 Auto shopping lists</li>
                    <li>⚖️ Fair meal rotation</li>
                  </ul>
                </div>
                
                <div className="app-status coming-soon">
                  <span className="status-badge">Coming Soon</span>
                </div>
              </div>
              
              <div className="app-card-actions">
                <Link to="/apps/dishlist" className="learn-more-btn secondary">
                  Learn More & Preview
                </Link>
              </div>
            </div>

            {/* PawKit App Card */}
            <div className="app-card">
              <div className="app-card-header">
                <h2>PawKit</h2>
                <p className="app-tagline">Connect pet owners with trusted pet sitters</p>
              </div>
              
              <div className="app-card-content">
                <div className="app-preview">
                  <div className="app-icon">🐾</div>
                  <p>Make pet sitting stress-free for everyone. Create comprehensive pet profiles with all the info sitters need - from feeding schedules to vet details.</p>
                </div>
                
                <div className="app-highlights">
                  <ul>
                    <li>📋 Complete pet profiles</li>
                    <li>💊 Medication schedules</li>
                    <li>🥘 Feeding instructions</li>
                    <li>🏥 Vet contact info</li>
                  </ul>
                </div>
                
                <div className="app-status coming-soon">
                  <span className="status-badge">In Development</span>
                </div>
              </div>
              
              <div className="app-card-actions">
                <Link to="/apps/pawkit" className="learn-more-btn secondary">
                  Learn More & Preview
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="why-42pets">
        <div className="content-wrapper">
          <h2>Why 42 Pets Apps?</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <h3>🎯 Focused Solutions</h3>
              <p>Each app solves a specific, real-world problem that we've experienced ourselves.</p>
            </div>
            <div className="benefit-item">
              <h3>👨‍👩‍👧‍👦 Family-First</h3>
              <p>Designed with busy families in mind, making daily life a little bit easier.</p>
            </div>
            <div className="benefit-item">
              <h3>📱 iOS Excellence</h3>
              <p>Native iOS apps that feel right at home on your iPhone and iPad.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Apps;
